import { Component, Input, OnInit, ElementRef, ViewChild, Optional } from '@angular/core';
import Hls from 'hls.js';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styles: [`
    .video-container {
      width: 100%;
      max-width: 100%;
    }
    .video-player {
      width: 100%;
      max-width: 100%;
    }
  `]
})
export class VideoPlayerComponent implements OnInit {
    @Input() document: any; // DocumentEntite type
    @ViewChild('videoPlayer') videoPlayer!: ElementRef;

    private hls: Hls | null = null;

    constructor(@Optional() private dialogRef: DynamicDialogRef,
                @Optional() private dialogConfig: DynamicDialogConfig,
                private messageService: MessageService) { }

    ngOnInit() {
        if (this.dialogConfig) {
            this.document = this.dialogConfig.data.document;
        }
        this.initPlayer();
    }

    ngOnDestroy() {
        if (this.hls) {
            this.hls.destroy();
        }
    }

    private async initPlayer() {
        let self = this;

        if (!self.document?.cheminFichier) {
            console.error('No video URL provided');
            return;
        }


        let video: HTMLVideoElement;
        while (!self.videoPlayer?.nativeElement) {
            // Wait for video player to be available
            await new Promise(resolve => setTimeout(resolve, 100));
        }

        video = self.videoPlayer.nativeElement;


        // Check if HLS is supported natively
        if (video.canPlayType('application/vnd.apple.mpegurl')) {
            // Native HLS support (Safari)
            video.src = self.document.cheminFichier;
        } else if (Hls.isSupported()) {
            // Use HLS.js for other browsers

            self.hls = new Hls();
            self.hls.loadSource(self.document.cheminFichier);
            self.hls.attachMedia(video);


            self.hls.on(Hls.Events.ERROR, (event, data) => {
                self.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la lecture de la vidéo' });
                console.error('HLS error:', data);
            });

        } else {
            self.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'HLS n\'est pas supporté dans ce navigateur' });
            console.error('HLS is not supported in this browser');
        }

    }

    getPosterUrl(): string {
        // Extract video ID from Cloudflare Stream URL and construct thumbnail URL
        // Example URL format: https://customer-{hash}.cloudflarestream.com/{videoId}/manifest/video.m3u8
        const videoId = this.document?.cheminFichier?.split('/')?.[3];
        return videoId ? `https://videodelivery.net/${videoId}/thumbnails/thumbnail.jpg` : '';
    }
}